export const useHandleError = (error, fatal = false) => {
    return {
        statusCode: error?.statusCode || 400,
        statusText: error?.data?.message || error?.statusMessage || 'Incorrect request',
        fatal,
    };
};
